import { ThrowLiteError } from '../lite-error.js';

function createFrameGraph(_engine) {
  const fg = {
    _tasks: [],
    _currentProcessedTask: null,
    build() {
      for (let i = 0; i < fg._tasks.length; i++) {
        recordTask(fg, fg._tasks[i]);
      }
      for (const task of fg._tasks) {
        for (const pass of task._passes) {
          pass._initialize();
        }
      }
    },
    execute() {
      let drawCalls = 0;
      for (const task of fg._tasks) {
        if (task.executionEnabled === false) {
          continue;
        }
        if (task.execute) {
          drawCalls += task.execute();
        } else {
          for (const pass of task._passes) {
            drawCalls += pass._execute();
          }
        }
      }
      return drawCalls;
    },
    dispose() {
      for (const task of fg._tasks) {
        task.dispose();
      }
      fg._tasks.length = 0;
      fg._currentProcessedTask = null;
    }
  };
  return fg;
}
function buildFrameGraphTask(fg, task) {
  if (!fg._tasks.includes(task)) {
    ThrowLiteError(94, task.name);
  }
  recordTask(fg, task);
  for (const pass of task._passes) {
    pass._initialize();
  }
}
function recordTask(fg, task) {
  task._passes.length = 0;
  fg._currentProcessedTask = task;
  try {
    task.record();
  } finally {
    fg._currentProcessedTask = null;
  }
}
function _appendTask(fg, task) {
  fg._tasks.push(task);
}

export { _appendTask, buildFrameGraphTask, createFrameGraph };
//# sourceMappingURL=frame-graph.js.map
